<template>
    <paper class="operate-delegate-dialog">
        <el-button v-if="!isApprove" style="margin: 0 0 10px 20px;" @click="close">返回</el-button>
        <el-button v-if="operateType !== OPERATE_TYPES.AUDIT" :disabled="[AUDIT_STATUS.WAIT,AUDIT_STATUS.PENDING].includes(auditStatus)" type="primary" :loading="submitLoading" @click="confirm('save')">保存</el-button>
        <el-button v-if="operateType === OPERATE_TYPES.EDIT" :disabled="auditStatus !== AUDIT_STATUS.NEW" type="primary" @click="del">删除</el-button>
        <el-button v-if="operateType !== OPERATE_TYPES.AUDIT" type="primary" :loading="submitLoading" @click="confirm('submit')">提交审批</el-button>
        <AuditMsg v-if="isApprove" :warehouseDelegateNo="currentRow.warehouseDelegateNo" @submit="handleAudit" >
            <el-button slot="outerBtn" :disabled="auditStatus !== AUDIT_STATUS.NEW" type="primary" @click="del">删除</el-button>
            <el-button slot="innerBtn" :disabled="auditStatus !== AUDIT_STATUS.NEW" type="primary" @click="del">删除</el-button>
        </AuditMsg>
        <el-form
            class="operate-delegate-form"
            v-loading="loading"
            ref="form"
            :model="form"
            :rules="rules"
            label-width="110px"
            size="mini"
            label-position="left"
        >
            <el-row :gutter="16">
                <el-col :span="8">
                    <OcrCardUpload
                        cardTitle="身份证(人像面)"
                        flag="idCardFrontFileId#idCardFrontFileUrl#idCardFrontFileName"
                        ocr="idCardFont"
                        label="身份证(人像面)"
                        :imgValue="form.idCardFrontFileUrl"
                        :imgExampleValue="imgExample.idCardFrontFileUrl"
                        :disabled="isApprove"
                        :drag="true"
                        :isRequired="true"
                        :size="10"
                        @uploadSuccess="handleOcrUploadSuccess"
                        @preview="handlePreview(form.idCardFrontFileUrl)"
                    />
                </el-col>
                <el-col :span="8">
                    <OcrCardUpload
                        cardTitle="身份证(国徽面)"
                        flag="idCardVersoFileId#idCardVersoFileUrl#idCardVersoFileName"
                        ocr="idCardBehind"
                        label="身份证(国徽面)"
                        :imgValue="form.idCardVersoFileUrl"
                        :imgExampleValue="imgExample.idCardVersoFileUrl"
                        :disabled="isApprove"
                        :drag="true"
                        :isRequired="true"
                        :size="10"
                        @uploadSuccess="handleOcrUploadSuccess"
                        @preview="handlePreview(form.idCardVersoFileUrl)"
                    />
                </el-col>
                <el-col :span="8" style="padding-top: 10px;">
                    <el-form-item label="姓名" prop="workerName">
                        <el-input v-model.trim="form.workerName" :disabled="isApprove || !isValidIdCard" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="身份证号" prop="idCardNo">
                        <el-input v-model.trim="form.idCardNo" :disabled="isApprove" placeholder="请输入身份证号" @blur="handleBlurIdCard"></el-input>
                    </el-form-item>
                    <el-form-item label="身份证起始期" prop="effectStartDate">
                        <el-date-picker
                            v-model="form.effectStartDate"
                            :disabled="isApprove || !isValidIdCard"
                            type="date"
                            placeholder="请输入日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="startPickerOptions"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="身份证有效期" prop="effectEndDate">
                        <el-date-picker
                            v-model="form.effectEndDate"
                            :disabled="isApprove || !isValidIdCard"
                            type="date"
                            placeholder="请输入日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="endPickerOptions"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="手机号码" prop="workerPhone">
                        <el-input v-model.trim="form.workerPhone" :disabled="isApprove || !isValidIdCard" placeholder="请输入手机号码"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="16">
                <el-col :span="6">
                    <el-form-item label="法务合同号" prop="legalContractCode">
                        <SrmAdvance
                            :disabled="isApprove || !isValidIdCard"
                            :params="contractConfig"
                            :formData="contractFormData"
                            :mValue="form.legalContractCode"
                            :customClass="'storage-delegate-contract-advance-dialog'"
                            @getAdvanceValue="getAdvanceValue($event, 'legalContractCode')"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="6" v-show="false">
                    <el-form-item label="物理仓" prop="physicalWarehouseName">
                        <el-input v-model.trim="form.physicalWarehouseName" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="仓库人员类型" prop="workerType">
                        <MSelect :value="form.workerType" :optionNum="'WAREHOUSE_WORKER_TYPE'" :disabled="isApprove || !isValidIdCard" placeholder="仓库人员类型" @input="val => propsChange(val, 'workerType')"></MSelect>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="主工作逻辑仓" prop="mainLogicalWarehouseName">
                            <SrmAdvance
                                :params="logicalWarehouseParams"
                                :mValue="form.mainLogicalWarehouseName"
                                :icon="'el-icon-s-custom'"
                                @getAdvanceValue="getAdvanceValue($event, 'mainLogicalWarehouseName')" />
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="发薪日期配置" prop="salaryPaydayCode">
                        <MSelect :value="form.salaryPaydayCode" :optionNum="'SALARY_PAYDAY'" :disabled="true" placeholder="发薪日期配置"></MSelect>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="16">
                <el-col :span="8">
                    <el-form-item prop="delegateType" label="委派函">
                        <el-radio-group @change="getApprover" v-model="form.delegateType" :disabled="isApprove || !isValidIdCard || isSupplier">
                            <el-radio :label="DELEGATE_TYPES.ONLINE">线上</el-radio>
                            <el-radio :label="DELEGATE_TYPES.OFFLINE">线下</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- 委派函 -->
            <div class="delegate-wrapper" v-if="form.delegateType === DELEGATE_TYPES.ONLINE">
                <el-row :gutter="16">
                    <el-col :span="8">
                        <el-form-item label="选择签署人" prop="signerName">
                            <SrmAdvance
                                :params="stamperParams"
                                :disabled="!form.supplierCode || isApprove || !isValidIdCard"
                                :formData="{ supplierCode: form.supplierCode }"
                                :mValue="form.signerName"
                                :icon="'el-icon-s-custom'"
                                @getAdvanceValue="getAdvanceValue($event, 'signerName')"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="签署人手机号" prop="signerPhone">
                            <el-input disabled v-model="form.signerPhone"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-tooltip class="delegate-start-time-tooltip" effect="dark" content="默认赋值提交时间" placement="top">
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                        <el-form-item label="委派开始时间" prop="delegateStartTime" class="delegateStartTime">
                            <el-date-picker
                                value-format="yyyy-MM-dd"
                                v-model="form.delegateStartTime"
                                disabled
                                type="date"
                                placeholder="请输入日期"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="16" class="delegate-time-row">
                    <el-col :span="8">
                        <el-tooltip class="delegate-end-time-tooltip" effect="dark" content="默认赋值合同终止时间" placement="top">
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                        <el-form-item label="委派结束时间" prop="delegateEndTime" class="delegateEndTime">
                            <el-date-picker
                                value-format="yyyy-MM-dd"
                                v-model="form.delegateEndTime"
                                disabled
                                type="date"
                                placeholder="请输入日期"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <div class="delegate-wrapper" v-else-if="form.delegateType === DELEGATE_TYPES.OFFLINE">
                <el-form-item label="纸质委派函上传" prop="warehouseDelegateFlieList" v-if="!isApprove">
                    <Upload
                        uploadDisplayType="button"
                        text="选择文件"
                        :fileTypeReg="/\.(jpg|jpeg|png|pdf)$/"
                        accept=".png,.jpg,.jpeg,.pdf"
                        :disabled="form.warehouseDelegateFlieList.length >= 5 || isSupplier || isPendingOrAdopt"
                        @uploadSuccess="handleUploadSuccess"
                    />
                    <el-button type="text" :loading="tempLoading" :disabled="isSupplier" @click="handleTemp">下载模板</el-button>
                </el-form-item>
                <AttachmentTable
                    :tableData="form.warehouseDelegateFlieList"
                    :isApprove="isApprove"
                    :isPendingOrAdopt="isPendingOrAdopt"
                    @preview="handlePreview"
                    @reupload="handleReupload"
                    @delete="handleDelete"
                />
                <el-row :gutter="16" class="delegate-time-row">
                    <el-col :span="8">
                        <el-tooltip class="delegate-start-time-tooltip" effect="dark" content="默认赋值提交时间" placement="top">
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                        <el-form-item label="委派开始时间" prop="delegateStartTime" class="delegateStartTime">
                            <el-date-picker
                                value-format="yyyy-MM-dd"
                                v-model="form.delegateStartTime"
                                disabled
                                type="date"
                                placeholder="请输入日期"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-tooltip class="delegate-end-time-tooltip" effect="dark" content="默认赋值合同终止时间" placement="top">
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                        <el-form-item label="委派结束时间" prop="delegateEndTime" class="delegateEndTime">
                            <el-date-picker
                                value-format="yyyy-MM-dd"
                                v-model="form.delegateEndTime"
                                disabled
                                type="date"
                                placeholder="请输入日期"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <!-- <el-row :gutter="16" class="delegate-time-row">
                <el-col :span="16">
                    <el-form-item label="仓库人员审批人" prop="approverList">
                        <div tabindex="0" @keyup.backspace="handleBackSpace" v-clickoutside="handleClickOutside" :class="['approver-wrap',isFocus && 'focus']" @click="focusApprover">
                            <el-tag
                                @close="delApprover(idx)"
                                class="approver-tag"
                                v-for="(tag, idx) in form.approverList"
                                :key="tag.approvalCode"
                                :effect="isFocus ?'dark' : 'light'"
                                :closable="form.approverList.length > 1 && operateType !== OPERATE_TYPES.AUDIT"
                                disable-transitions
                                :type="isFocus ? '' : 'info'">
                                {{tag.approvalName}}
                            </el-tag>
                        </div>
                        <div class="approver-tips">可以删减人员，不可以更换，最少保留一人，最多20人</div>
                    </el-form-item>
                </el-col>
            </el-row> -->
        </el-form>
        <Preview
            v-if='attachmentShow'
            :attachmentList="attachmentList"
            :attachmentShow.sync='attachmentShow'
            :rowData='rowData'>
        </Preview>
    </paper>
</template>

<script>
import Clickoutside from 'element-ui/src/utils/clickoutside'
import dayjs from 'dayjs';
import MSelect from '@/components/lots/otpSelect2/index'
import SrmAdvance from '../../../components/srmAdvance/index.vue'
import OcrCardUpload from '../../../components/ocrCardUpload/Index.vue';
import Upload from '../../../components/upload/Index.vue'
import Preview from '../../../components/viewAttachment.vue';
import AuditMsg from './AuditMsg.vue';
import Paper from '@/components/core/paper/Paper'
import AttachmentTable from './AttachmentTable.vue'
import { identityVerify } from '../../../constant/formRegular.js';
import { DELEGATE_TYPES, INIT_FORM, RULES, startPickerOptions, endPickerOptions, contractConfig, OPERATE_TITLES, OPERATE_TYPES, AUDIT_STATUS } from './constant.js'
import { verifyDate } from '../../../utils/common.js';
import { stamperParams } from '../../register/manage/keyData/tabs/driver/newUploadVersion/config.js'
import { getWorkerPage, checkChange, submitApprove, getDelegateDetail, downloadTemplate, queryApprove, supplierWarehouseDelegateSave, supplierWarehouseDelegateDel, queryPaydayConfig, checkSalaryPayday } from '../../../api/warehouseResourceManagement/warehouseDelegationLetter.js';
const workerDtoKeys = [
    'workerType', 'idCardFrontFileId', 'idCardFrontFileUrl', 'idCardFrontFileName', 'idCardVersoFileId', 'idCardVersoFileUrl', 'idCardVersoFileName',
    'workerName', 'idCardNo', 'effectStartDate', 'effectEndDate', 'workerPhone'

]

export default {
    name: 'warehouseDelegationApprove',
    components: { Paper, MSelect, SrmAdvance, OcrCardUpload, Upload, Preview, AuditMsg, AttachmentTable },
    props: { },
    directives: { Clickoutside },
    data() {
        return {
            loading: false,
            submitLoading: false,
            tempLoading: false,
            operateType: null, // 当前操作类型：新增、编辑或审批
            OPERATE_TYPES,
            DELEGATE_TYPES,
            AUDIT_STATUS,
            // visible: false,
            currentRow: {},
            form: JSON.parse(JSON.stringify(INIT_FORM)),
            // 示例封面图片
            imgExample: {
                idCardFrontFileUrl: require('../../register/manage/keyData/tabs/driver/newUploadVersion/example/idCardFile.jpg'), // 身份证(人像面)
                idCardVersoFileUrl: require('../../register/manage/keyData/tabs/driver/newUploadVersion/example/idCardBottomSideFile.jpg'), // 身份证(国徽面)
            },
            rules: { ...RULES },
            stamperParams: {
                ...stamperParams,
                value: 'signerName',
                advanceCascade: 'supplierCode',
                cbParams: ['stamperCode#signerCode', 'stamperName#signerName', 'stamperMobile#signerPhone']
            },
            logicalWarehouseParams: {
                name: '主工作逻辑仓',
                value: 'cdwhName',
                type: 'advance',
                advanceLabel: '逻辑仓弹出框',
                advanceConfig: [
                    { prop: 'cdwhName', value: '逻辑仓名称' },
                    { prop: 'whCode', value: '逻辑仓编码' }
                ],
                tableConfig: [
                    { prop: 'whCode', value: '逻辑仓编码' },
                    { prop: 'cdwhName', value: '名称' },
                ],
                advanceUrl: '/public/api/searchCdWarehouse',
                prefix: '/api-srm',
                method: 'get',
                cbParams: ['cdwhName#mainLogicalWarehouseName', 'whCode#mainLogicalWarehouseCode'],
                // advanceCascade: 'companyCode#cdRunSiteCodes',
                // multiple: true,
                // multipleTableColumn: { prop: 'cdwhName', value: '名称' },
                // multipleDelConfirm: true,
            },
            attachmentShow: false,
            attachmentList: [],
            rowData: {},
            startPickerOptions,
            endPickerOptions,
            searchedIdCard: null, // 查询过的司机信息身份证号
            auditStatus: null, // 审批流程状态
            isFocus: false,
        };
    },
    computed: {
        title() {
            return OPERATE_TITLES[this.operateType] || ''
        },
        isApprove() {
            return this.operateType === OPERATE_TYPES.AUDIT
        },
        // 校验是否为有效身份证号
        isValidIdCard() {
            return this.form.idCardNo && identityVerify.test(this.form.idCardNo)
        },
        isSupplier() {
            return !!this.$store.state.supplier
        },
        contractConfig() {
            const advanceConfig = JSON.parse(JSON.stringify(contractConfig))
            advanceConfig.advanceUrl = this.isSupplier ? '/contract/supplierWarehouseContractPage' : '/contract/warehouseContractPage'
            advanceConfig.cbParams = ['contractCode', 'legalContractCode', 'contractName', 'supplierCode', 'supplierName', 'expirationDate','logicalWarehouseName','logicalWarehouseCode', 'physicalWarehouseName','physicalWarehouseCode', 'siteCode']
            return advanceConfig
        },
        contractFormData() {
            return this.isSupplier ? { supplierCode: this.$store.state.supplier.supplierCode } : {}
        },
        isPendingOrAdopt() {
            // WAREHOUSE_DELEGATE_AUDIT_STATUS
            const PENDING = '3' // 审批中
            // const ADOPT = '20' // 审批通过
            return this.auditStatus && [PENDING].includes(this.auditStatus)
        }
    },
    provide() {
        return {
            paydayCheck: this.paydayCheck
        };
    },
    mounted(){
        if (this.$route.query.id) {
            this.currentRow = {
                id: this.$route.query.id,
                warehouseDelegateNo: this.$route.query.warehouseDelegateNo,
            }
            this.getDetail()
        }
        this.operateType = this.$route.query.type
    },
    activated(){
        if (this.$route.query.id) {
            this.currentRow = {
                id: this.$route.query.id,
                warehouseDelegateNo: this.$route.query.warehouseDelegateNo,
            }
            this.getDetail()
        }else{
            //新建
            if(this.operateType === OPERATE_TYPES.ADD){
                //上一次是新建则不清空内容
            }else{
                this.form = JSON.parse(JSON.stringify(INIT_FORM))
                this.currentRow = {}
                this.searchedIdCard = null
                this.auditStatus = null
            }
            this.getPayday()
        }
        this.operateType = this.$route.query.type
        
        this.$nextTick(() => {
            this.$refs.form.clearValidate()
        })
    },
    methods: {
        // getSelectedValue(val, prop) {
        //     this.$set(this.form, prop, val);
        // },
        // open(operateType, row) {
        //     this.operateType = operateType
        //     if (row) {
        //         this.currentRow = row
        //         this.getDetail()
        //     }
        //     this.visible = true
        // },
        handleClickOutside(){
            this.isFocus = false  
        },
        focusApprover(){
            if(this.operateType !== OPERATE_TYPES.AUDIT){
                this.isFocus = true
            }
        },
        del(){
            this.$confirm(`请确认是否删除?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                supplierWarehouseDelegateDel(this.form.id).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('删除成功!')
                        this.close()
                    }
                })
            })
        },
        save(){
            this.submitLoading = true
            supplierWarehouseDelegateSave(this.getParams()).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('保存成功!')
                    this.close()
                }
            }).finally(() => {
                this.submitLoading = false
            })
        },
        close() {
            let path = this.$store.state.supplier ? '/lsrm/warehouseDelegationLetter' : '/warehouseDelegationLetter'
            this.$router.replace(path)
        },
        handleBackSpace(){
            if(this.isFocus && this.form.approverList.length > 1 && this.operateType !== OPERATE_TYPES.AUDIT){
                this.delApprover(this.form.approverList.length - 1)
            }
        },
        delApprover(idx){
            this.form.approverList.splice(idx, 1)
            this.$nextTick(() => {
                this.$refs['form'].validateField('approverList')
            })
        },
        // 获取仓库人员审批人
        getApprover(){
            if(this.form.delegateType && this.form.legalContractCode && this.form.siteCode){
                queryApprove({delegateType: this.form.delegateType, legalContractCode: this.form.legalContractCode, siteCode: this.form.siteCode }).then(res => {
                    if (res && +res.code === 0) {
                            this.form.approverList = res.data || []
                    }else{
                        this.form.approverList = []
                    }
                    this.$nextTick(() => {
                        this.$refs['form'].validateField('approverList')
                    })
                })
            }
        },
        confirm(type) {
            if (!this.form.idCardFrontFileUrl) {
                return this.$message.warning('请上传身份证(人像面)');
            } else if (!this.form.idCardVersoFileUrl) {
                return this.$message.warning('请上传身份证(国徽面)');
            }
            if(this.form.approverList.length > 20){
                return this.$message.warning('审批人不可超过20人');
            }
            this.$refs['form'].validate().then(async () => {
                if(type === 'save'){
                    this.paydayCheck(this.save)
                }else{
                    this.paydayCheck(this.checkChangeAndSubmit)
                }
            })
        },
        async paydayCheck(callback) {
            // 发薪日期校验
            const params = {
                contractCode: this.form.contractCode,
                mainLogicalWarehouseCode: this.form.mainLogicalWarehouseCode,
                salaryPaydayCode: this.form.salaryPaydayCode
            }
            this.submitLoading = true
            const checkSpRes = await checkSalaryPayday(params).catch(err => {})
            this.submitLoading = false
            if (!checkSpRes || +checkSpRes.code !== 0) {
                return false
            }
            if (checkSpRes.data && checkSpRes.data.paydayConfigHeadCode) {
                const msg = this.isSupplier ?
                    '该合同的发薪日期为空，请告知现场人员发薪日期，并联系现场人员维护' :
                    '该合同的发薪日期为空，请前往发薪日期配置维护日期并启用'
                const confirmButtonText = this.isSupplier ? '已知晓并继续提交' : '去维护'
                this.$confirm(msg, '提示', {
                    confirmButtonText: confirmButtonText,
                    cancelButtonText: '取消',
                    showCancelButton: this.isSupplier,
                    showClose: true,
                }).then(() => {
                    if (this.isSupplier) {
                        callback && callback()
                    } else {
                        this.$router.push({
                            path: '/salaryDateConfigDetail',
                            query: {
                                id: checkSpRes.data.paydayConfigHeadCode,
                            }
                        })
                    }
                }).catch(() => { });
            } else {
                callback && callback()
            }
        },
        // 校验变更及提交审批
        async checkChangeAndSubmit() {
            this.submitLoading = true
            const checkRes = await checkChange(this.getParams()).catch(err => {})
            this.submitLoading = false
            if (!checkRes || +checkRes.code !== 0) {
                return false
            }
            if (checkRes.data) {
                this.$confirm(checkRes.data, '提示', {
                    customClass: 'storage-delegate-dialog-check-confirm',
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'info'
                }).then(() => {
                    this.submit()
                }).catch(() => { });
            } else {
                this.submit()
            }
        },
        submit() {
            this.submitLoading = true
            submitApprove(this.getParams()).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('提交审批成功!')
                    this.$emit('refresh')
                    this.close()
                }
            }).finally(() => {
                this.submitLoading = false
            })
        },
        getParams() {
            const params = {}
            params.id = this.currentRow.id || null
            params.warehouseDelegateNo = this.currentRow.warehouseDelegateNo || null
            params.legalContractCode = this.form.legalContractCode
            params.contractCode = this.form.contractCode
            params.contractName = this.form.contractName
            params.delegateType = this.form.delegateType
            params.supplierCode = this.form.supplierCode
            params.supplierName = this.form.supplierName
            params.approverList = this.form.approverList
            params.physicalWarehouseCode = this.form.physicalWarehouseCode
            params.physicalWarehouseName = this.form.physicalWarehouseName
            params.logicalWarehouseName = this.form.logicalWarehouseName
            params.logicalWarehouseCode = this.form.logicalWarehouseCode
            params.mainLogicalWarehouseName = this.form.mainLogicalWarehouseName
            params.mainLogicalWarehouseCode = this.form.mainLogicalWarehouseCode

            params.workerDto = {}
            workerDtoKeys.forEach(key => {
                params.workerDto[key] = this.form[key]
            })

            if (this.form.delegateType === DELEGATE_TYPES.ONLINE) {
                params.signerCode = this.form.signerCode
                params.signerName = this.form.signerName
                params.signerPhone = this.form.signerPhone
            } else if (this.form.delegateType === DELEGATE_TYPES.OFFLINE) {
                params.warehouseDelegateFlieList = this.form.warehouseDelegateFlieList
            }
            params.delegateStartTime = this.form.delegateStartTime
            params.delegateEndTime = this.form.delegateEndTime
            params.dataSource = !!this.isSupplier ? 'LSP' : 'LSRM'

            return params
        },
        // 切换委派函线上线下
        radioChange(val) { },
        propsChange(val, prop) {
            this.form[prop] = val
        },
        getAdvanceValue(val, prop) {
            if (prop === 'legalContractCode') {
                this.form.legalContractCode = val.legalContractCode
                this.form.contractCode = val.contractCode
                this.form.contractName = val.contractName
                this.form.logicalWarehouseName = val.logicalWarehouseName
                this.form.logicalWarehouseCode = val.logicalWarehouseCode
                this.form.physicalWarehouseCode = val.physicalWarehouseCode
                this.form.physicalWarehouseName = val.physicalWarehouseName
                this.form.delegateEndTime = val.expirationDate ? dayjs(val.expirationDate).format('YYYY-MM-DD HH:mm:ss') : null
                this.form.supplierCode = val.supplierCode
                this.form.supplierName = val.supplierName
                this.form.signerCode = null
                this.form.signerName = null
                this.form.signerPhone = null
                this.form.siteCode = val.siteCode
                this.getApprover()
                this.getPayday()
            } else if (prop === 'signerName') {
                this.form.signerCode = val.signerCode
                this.form.signerName = val.signerName
                this.form.signerPhone = val.signerPhone
            }
            else if (prop === 'mainLogicalWarehouseName') {
                this.form.mainLogicalWarehouseName = val.mainLogicalWarehouseName
                this.form.mainLogicalWarehouseCode = val.mainLogicalWarehouseCode
                this.getPayday()
            }
        },
        handleOcrUploadSuccess(result) {
            const id = result.flag.split('#')[0]
            const url = result.flag.split('#')[1]
            const name = result.flag.split('#')[2]
            const ocrResult = result.data.ocrResult
            const ossResult = result.data.ossResult
            this.form[id] = ossResult.id
            this.form[url] = ossResult.downUrl
            this.form[name] = ossResult.localFileName
            // this.fileObj[url] = responseData
            // // 设置文件上传成功返回的数据
            // this.setResponseFormData(responseData, name, url, id)
            if (ocrResult) {
                switch (id) {
                case 'idCardFrontFileId':
                    // 设置身份证正面带出的数据
                    this.setIdCardFileFormData(ocrResult)
                    break
                case 'idCardVersoFileId':
                    // 设置身份证背面带出的数据
                    this.setIdCardBottomSideFileFormData(ocrResult)
                    break
                default: break
                }
                // 如果身份证号存在，查询系统数据库中是否有关联信息
                if (ocrResult.idNumber) {
                    this.handleBlurIdCard()
                }
            }
        },
        // 设置上传身份证正面后带出来的数据
        setIdCardFileFormData(info) {
            if (!info) {
                // 防止相片不清晰后台传回null
                return this.$message.warning('相片真实性或清晰度欠佳，若条件允许，建议重新上传');
            }
              
            this.form.workerName = info.name
            this.form.idCardNo = info.idNumber
        },
        // 设置上传身份证反面后带出来的数据
        setIdCardBottomSideFileFormData(info) {
            if (!info) {
                return this.$message.warning('相片真实性或清晰度欠佳，若条件允许，建议重新上传');
            }
            this.form.effectStartDate = verifyDate(info.idCardStartTime);
            this.form.effectEndDate = info.idCardEndTime === '长期' ? '2099-12-31' : verifyDate(info.idCardEndTime);
            if (!info.idCardStartTime || !info.idCardEndTime) {
                this.$message.warning('身份证相片真实性或清晰度欠佳，若条件允许，建议重新上传');
            }
        },
        handleBlurIdCard() {
            // 编辑时，或输入身份证号为空，或与上次相同时，都不进行查询
            if (this.id || !this.form.idCardNo || this.form.idCardNo === this.searchedIdCard) {
                return false
            }
            this.searchedIdCard = this.form.idCardNo
            getWorkerPage({ idCardNo: this.form.idCardNo }).then(res => {
                if (res && +res.code === 0) {
                    Object.keys(this.form).forEach(key => {
                        // 身份证、身份证证件字段、名称有值才覆盖，其他字段不判断是否有值
                        if (['idCardNo', 'idCardFrontFileId', 'idCardFrontFileUrl', 'idCardFrontFileName', 'workerName'].includes(key)) {
                            if (res.data.list.length && res.data.list[0][key]) {
                                this.form[key] = res.data.list[0][key]
                            }
                        } else if ([
                                'delegateType', 'warehouseDelegateFlieList', 'delegateStartTime', 'delegateEndTime', 'signerCode', 'signerName', 'signerPhone', 'approverList', 'siteCode', 'physicalWarehouseName',
                                'legalContractCode', 'contractCode', 'contractName', 'supplierCode', 'supplierName', 'id'
                            ].includes(key)) {
                                // 委派函相关字段、合同相关及所带出字段不作覆盖
                                return false
                        } else {
                            this.form[key] = res.data.list.length ? res.data.list[0][key] : null
                        }
                    })
                }
            })
        },
        handleUploadSuccess(result) {
            this.form.warehouseDelegateFlieList.unshift({
                id: null,
                warehouseDelegateCode: null,
                fileId: result.data.data.id,
                fileUrl: result.data.data.downUrl,
                fileName: result.data.data.localFileName,
                uploadTime: dayjs(result.data.timestamp).format('YYYY-MM-DD HH:mm:ss')
            })
        },
        handlePreview(downUrl) {
            if (!downUrl) {
                return this.$message.warning('暂无可预览的文件!')
            }
            this.attachmentShow = true
            this.rowData = { downUrl }
        },
        handleReupload(result, index) {
            this.form.warehouseDelegateFlieList[index].fileId = result.data.data.id
            this.form.warehouseDelegateFlieList[index].fileUrl = result.data.data.downUrl
            this.form.warehouseDelegateFlieList[index].fileName = result.data.data.localFileName
            this.form.warehouseDelegateFlieList[index].uploadTime = dayjs(result.data.timestamp).format('YYYY-MM-DD HH:mm:ss')
            this.form.warehouseDelegateFlieList.sort((a, b) => dayjs(b.uploadTime).valueOf() - dayjs(a.uploadTime).valueOf())
        },
        handleDelete(index) {
            this.form.warehouseDelegateFlieList.splice(index, 1)
        },
        getDetail() {
            this.loading = true
            getDelegateDetail(this.currentRow.warehouseDelegateNo).then(res => {
                if (res && +res.code === 0) {
                    Object.keys(this.form).forEach(key => {
                        this.form[key] = res.data[key] || null
                        if (key === 'warehouseDelegateFlieList' || key === 'approverList') {
                            this.form[key] = res.data[key] || []
                        }
                    })

                    workerDtoKeys.forEach(key => {
                        this.form[key] = res.data.workerDto[key] || null
                    })
                    // 详情接口若未返回审批人，再调审批人查询接口
                    if (!this.form.approverList || !this.form.approverList.length) {
                        this.getApprover()
                    }

                    this.auditStatus = res.data.auditStatus
                }
            }).finally(() => { this.loading = false })
        },
        handleTemp() {
            this.tempLoading = true
            downloadTemplate().then(res => {
                if (res && +res.code === 0) {
                    const a = document.createElement('a')
                    a.href = res.data.downUrl
                    a.download = res.data.localFileName
                    a.click()
                    this.$message.success('下载成功')
                }
            }).finally(() => { this.tempLoading = false })
        },
        handleAudit() {
            setTimeout(() => {
                this.$emit('refresh')
                this.close()
            }, 1500);
        },
        getPayday() {
            if (this.form.contractCode && this.form.mainLogicalWarehouseCode) {
                const params = {
                    contractCode: this.form.contractCode,
                    mainLogicalWarehouseCode: this.form.mainLogicalWarehouseCode,
                }
                queryPaydayConfig(params).then(res => {
                    if (res && +res.code === 0) {
                        this.form.salaryPaydayCode = res.data.salaryPaydayCode
                    }
                })
            }
        }
    },
}
</script>

<style lang="less">
.operate-delegate-dialog {
    min-height: calc(100% - 20px);
    .el-dialog__body {
        padding: 16px 0;
    }

    .operate-delegate-form {
        padding-right: 30px;
        padding-left: 30px;
    }

    .el-card { margin: 10px 0 22px; }

    .el-card__header {
        padding: 0 15px;
        height: 40px;
        line-height: 40px;
    }

    .ocr-upload-container { height: 170px; }

    .el-upload-dragger {
        width: 100%;
        height: 100%;
    }

    .el-date-editor.el-input {
        width: 100%;
    }

    .delegate-wrapper {
        padding: 18px 15px 0;
        margin-bottom: 17px;
        border: 1px solid #ccc;
    }

    .register-upload {
        display: inline-block;
        margin-right: 10px;
    }

    .delegate-time-row .el-col {
        position: relative;
    }

    .delegate-start-time-tooltip {
        position: absolute;
        top: 8px;
        left: 86px;
    }

    .delegate-end-time-tooltip {
        position: absolute;
        top: 8px;
        left: 93px;
    }

    .approver-wrap{
        padding: 10px;
        min-height: 50px;
        border: 1px solid rgb(206,206,206);
        border-radius: 4px;
        outline: none;
        box-sizing: border-box;

        &.focus{
            border-color: #00bcbf;
        }
    }

    .approver-tag{
        margin-right: 10px;
        margin-bottom: 10px;
    }

    .approver-tips{
        font-size: 12px;
        color: orange;
    }
}

.storage-delegate-contract-advance-dialog {
    .search-obj--key, .search-obj--keyword {
        display: none;
    }

    .config-footer .el-button--primary {
        padding: 7px 15px;
    }
}

.storage-delegate-dialog-check-confirm p {
    word-wrap: break-word;
    word-break: normal;
}
</style>
